import { useCallback, useEffect, useState } from 'react'

import { parseData } from 'core/classes/helpers'
import { CrudStore } from 'core/types/crudStore'

import { DEBUGGER_CRUD_NEW } from '../constants'
import { IIssueTopic } from '../models/IIssueTopic'
import { IPageTopic } from '../models/IPageTopic'

import { useDebuggerCrud } from './useDebuggerCrud'

export const usePageTopic = (pageId: string) => {
  const [topic, setTopic] = useState<IIssueTopic | null>(null)
  const [pageTopic, setPageTopic] = useState<IPageTopic | null>(null)
  const [topicUsers, setTopicUsers] = useState<string[]>([])
  const [isTopicLoading, setLoading] = useState<boolean>(false)

  const topicSource = useDebuggerCrud(DEBUGGER_CRUD_NEW.topics.key)
  const pageTopicSource = CrudStore.get(DEBUGGER_CRUD_NEW.pageTopics.key)

  const topicChangeHandler = useCallback((topic: IIssueTopic | null) => {
    setTopic(topic)
    if (topic?.Responsibles) {
      const responsibleUsers: string[] = parseData(topic.Responsibles, 'array')
      setTopicUsers(responsibleUsers)
    }
  }, [])

  useEffect(() => {
    setLoading(true)
    pageTopicSource
      .getById({ id: pageId, keyField: 'PageId' })
      .then((res) => {
        if (res) {
          setPageTopic(res)
          //TODO Remove and change query by 'res.TopicTitle' after fix from saving from backend
          const topicTitle = res.TopicTitle.replace('&amp;', '&')
          topicSource.getById({ id: topicTitle, keyField: 'Title' }).then((topicByTitle) => {
            if (topicByTitle) {
              topicChangeHandler(topicByTitle)
            }
          })
        } else {
          setPageTopic(null)
          topicChangeHandler(null)
        }
      })
      .finally(() => setLoading(false))
  }, [pageId, pageTopicSource, topicChangeHandler, topicSource])

  return { topic, isTopicLoading, pageTopic, topicChangeHandler, topicUsers }
}
